export default "__VITE_ASSET__CGZ_nE6K__"